import React, { Component } from 'react';

import FlatUIButton from "./flat-ui-button.js";
import anime from 'animejs';


class MultiSelect extends Component {
  submitted = false
  additional_data = { selections: [], meta: { rendered: performance.now() } }

  constructor(props) {
    super(props)

    this.state = {
      options: this.props.options.map(opt => {
        return {
          text: opt,
          selected: false
        }
      })
    }
  }

  getId(option) {
    return this.props.id + "-option_" + this.props.options.indexOf(option)
  }

  onSubmit() {
    if (this.submitted) return
    this.submitted = true

    let timestamp = performance.now()
    this.additional_data.submission_delay_time = timestamp - this.additional_data.meta.last_interaction

    let anim = anime.timeline()
    const computedStyles = getComputedStyle(document.body)
    // const primary = computedStyles.getPropertyValue('--primary').trim()
    // const shadow = computedStyles.getPropertyPriority('--shadow-1').trim()

    const selected = this.state.options.filter(opt => opt.selected).map(opt => opt.text)
    const unselected = this.state.options.filter(opt => !opt.selected).map(opt => opt.text)
    
    // console.log(el.clientWidth)

    const duration = 600
    const easing = 'easeOutQuad'
    anim
      .add({
        targets: [
          ".centered",
          ...unselected.map(opt => "#" + this.getId(opt))
        ],
        opacity: 0,
        duration: duration,
        easing: easing,
        complete: anim => {
          this.props.addMessage(JSON.stringify(this.state.options.filter(opt => opt.selected).map(opt => opt.text)), this.additional_data)
        },
        offset: 0,
      })
      .add({
        targets: selected.map(opt => "#" + this.getId(opt) + " span"),
        color: "#fff",
        duration: duration / 2,
        easing: easing,
        offset: 0
      })
      .add({
        targets: selected.map(opt => "#" + this.getId(opt)),
        backgroundColor: "#e71272",
        duration: 150,
        easing: easing,
        offset: 0
      })

    let xOffset = 0
    let yOffset = 0
    let height = 0

    selected.forEach(opt => {
      let xy = this.getXYOffsets(xOffset, yOffset, opt, height)
      let anim1 = this.getOptionAnimation(opt, duration, xy.x, xy.y, xy.width)
      anim.add(anim1)
      anim.add({
        targets: anim1.targets,
        duration: 150,
        offset: 0,
        easing: anim1.easing,
        backgroundColor: ["#e71272", "#008DD5"],
        boxShadow: "rgba(0, 0, 0, 0.5) 0px 1px 2px 0px",
      })
      xOffset = xy.xOffset
      yOffset = xy.yOffset
      height = xy.height
      // console.log(xy)
    })

    
      
  }

  getXYOffsets(xOffset, yOffset, text, previousHeight) {
    const el = document.getElementById(this.getId(text));

    // const computedStyles = getComputedStyle(document.body)
    // const margin = computedStyles.getPropertyValue('--spacing-small').trim()
    const styles = getComputedStyle(el)
    const marginLeft = 10 //+styles.marginLeft.slice(0, -2) || 10

    const innerWidth = el.firstChild.offsetWidth + 1
    const whiteSpaceWidth = (el.firstChild.offsetLeft) * 2 // padding
    const newWidth = innerWidth + whiteSpaceWidth

    const animateWidth = Math.abs(newWidth - el.offsetWidth) > 4
    const width = animateWidth ? newWidth : el.offsetWidth

    const newOffset = (el.offsetLeft - el.parentNode.offsetLeft) + (el.offsetWidth - width) / 2
    const desiredOffset = el.parentNode.clientWidth - xOffset - width

    // console.log(el.offsetLeft, el.parentNode.clientWidth, el.clientWidth)
    // console.log(xOffset, yOffset)
    if (desiredOffset < 0) {
      // Need to start a new row!
      console.log("Starting new row!")
      const marginBottom = +styles.marginBottom.slice(0, -2)
      const newYOffset = yOffset + previousHeight + marginBottom
      return this.getXYOffsets(0, newYOffset, text)
    }

    return {
      x: desiredOffset - newOffset,
      y: -1 * (el.offsetTop - el.parentNode.offsetTop) + yOffset,
      xOffset: xOffset + width + marginLeft,
      yOffset: yOffset,
      width: animateWidth ? width : null,
      height: el.offsetHeight
    }
  }

  getOptionAnimation(text, duration, x, y, width) {
    return {
        targets: "#" + this.getId(text),
        translateX: x + "px",
        translateY: y +  "px",
        width: width ? width + 'px' : null,
        boxShadow: "rgba(0, 0, 0, 0.5) 0px 1px 2px 0px",
        // borderWidth: '0px',
        duration: duration,
        easing: 'easeOutQuad',
        offset: 0, 
      }
  }


  toggle(opt) {
    if (this.props.inputDisabled || this.submitted) return

    opt.selected = !opt.selected;
    this.setState({
      options: this.state.options
    })

    let timestamp = performance.now()
    if (!this.additional_data.interaction_delay_time) {
      this.additional_data.interaction_delay_time = timestamp - this.additional_data.meta.rendered
    }
    if (this.additional_data.meta.last_interaction) this.additional_data.selections.push((timestamp - this.additional_data.meta.last_interaction).toString())
    this.additional_data.meta.last_interaction = timestamp

    if (opt.selected) {
      this.additional_data.selections.push(opt.text)
    } else {
      this.additional_data.selections.push("UNSELECTED: " + opt.text)
    }
  }


  render() {
    let buttons = this.state.options.map(opt => {
      return (
        <FlatUIButton className={opt.selected ? "primary" : ""} 
            key={opt.text} 
            id={this.getId(opt.text)}
            variant="raised" outline
            longAnswer={this.props.longAnswers}
            onClick={e => this.toggle(opt)}>
          {/*{ opt.selected && <Done className="button-left-icon" />}*/}
          {opt.text}
        </FlatUIButton>
      )
    })

    const noneSelected = this.state.options.every(opt => !opt.selected)

    return (
      <div className={"input " + this.props.className}>
        <div className={"select-many-choices" + (this.props.longAnswers ? " stacked" : "")}>
          { buttons }
        </div>
        <div className="centered submit-container">
          <FlatUIButton disabled={noneSelected} className="rounded primary submit-button" 
              onClick={e => this.onSubmit()}>
            OK
          </FlatUIButton>
        </div>
      </div>
    )
    
  }
}

export default MultiSelect;


// WEBPACK FOOTER //
// ./src/components/input/multi.js